import { CircularProgress } from "@mui/material";
import Grid from '@mui/material/Grid2';

import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { ElogMeetingContext } from "../context";
import ListView from "@common/components/ListDetailViews/ListView";
import { getColumns } from "./colDef";

const Attendance = () => {
  const { t } = useTranslation();
  const { form, dispatchElogMeeting } = useContext(ElogMeetingContext);
  const data = form.elogMeeting.elogAttendances ?? [];

  const updateElogAttendances = (
    id: number,
    actualAttendance: number | undefined
  ) =>
    dispatchElogMeeting({
      elogAttendances: data.map((room) =>
        room.id === id ? { ...room, actualAttendance } : room
      ),
    });
  const columns = getColumns(
    (id: number, checked: boolean) => {
      updateElogAttendances(id, checked ? 0 : undefined);
    },
    updateElogAttendances,
    t
  );
  return (
    <Grid
      container
      direction="column"
      sx={{ width: '100%', gap: "1rem",
        padding: "1rem",
        height: "100%" }}>
      {form.elogMeeting === undefined ? (
        <CircularProgress sx={{ position: "relative", left: "50%" }} />
      ) : (
        <Grid
          container
          wrap="nowrap"
          direction="column"
          sx={{ width: '100%', height: "100%",
            "& table": { "& th": { border: "none" } },
            gap: "1rem" }}>
          <Grid
            sx={{
              height: "100%",
              flexGrow: 1,
              overflow: "hidden"
            }}>
            <ListView
              disableColumnResize
              loading={data === undefined}
              data={
                data
                  ?.filter((elogAttendance) => elogAttendance.room != undefined)
                  .sort((a, b) =>
                    (a.room.name || "").localeCompare(b.room.name || "")
                  ) ?? []
              }
              columns={columns}
              total={data?.length}
            />
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default Attendance;
